// extracted by mini-css-extract-plugin
module.exports = {"phoneIcon":"PdpSharedCallDealerCta__phoneIcon__663a752"};